<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Fejl</h4>
        <button type="button" class="close" aria-label="Close"
                (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <code>
            {{ rawError }}
        </code>
    </div>
</ng-template>
<button type="button" class="btn btn-outline-warning" (click)="openModal(content)" *ngIf="niceError">
    {{ niceError }}
</button>
<span *ngIf="!niceError" class="text-success">OK</span>
